export enum UserStatus {
	UNAUTHORIZED = 'UNAUTHORIZED',
	UNVERIFIED = 'UNVERIFIED',
	VERIFIED = 'VERIFIED',
	UNKNOWN = 'UNKNOWN',
}
